const PREFIXES: [number, string][] = [
  [1e12, 'T'],
  [1e9, 'G'],
  [1e6, 'M'],
  [1e3, 'k'],
  [1, ''],
  [1e-3, 'm'],
  [1e-6, 'µ'],
  [1e-9, 'n'],
  [1e-12, 'p'],
];

/** 공학 표기로 값을 포맷한다. 예) 0.0047 -> "4.7 mA" */
export function fmt(value: number, unit = '', digits = 3): string {
  if (!Number.isFinite(value)) return '—';
  const abs = Math.abs(value);
  if (abs < 1e-13) return `0 ${unit}`.trim();

  for (const [scale, prefix] of PREFIXES) {
    if (abs >= scale * 0.999) {
      const v = value / scale;
      return `${trim(v, digits)} ${prefix}${unit}`.trim();
    }
  }
  return `${value.toExponential(2)} ${unit}`.trim();
}

function trim(v: number, digits: number): string {
  const abs = Math.abs(v);
  const dec = abs >= 100 ? Math.max(0, digits - 3) : abs >= 10 ? Math.max(0, digits - 2) : digits - 1;
  return parseFloat(v.toFixed(dec)).toString();
}

/** "4.7k", "2m", "1e3" 같은 입력을 숫자로 */
export function parseValue(text: string): number | null {
  const s = text.trim().replace(/[ΩVAFHs]/gi, '').trim();
  const m = /^(-?[\d.]+(?:[eE][-+]?\d+)?)\s*([a-zA-Zµμ]*)$/.exec(s);
  if (!m) return null;
  const base = parseFloat(m[1]);
  if (!Number.isFinite(base)) return null;
  const suffix = m[2];
  if (!suffix) return base;
  const table: Record<string, number> = {
    T: 1e12, G: 1e9, M: 1e6, meg: 1e6, k: 1e3, K: 1e3,
    m: 1e-3, u: 1e-6, µ: 1e-6, μ: 1e-6, n: 1e-9, p: 1e-12,
  };
  const mult = table[suffix] ?? table[suffix.toLowerCase()];
  return mult === undefined ? base : base * mult;
}
